<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ArenaPointTypeList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaPointTypeList from '@/components/settings/arena/point-type/ArenaPointTypeList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Company',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ArenaPointTypeList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addarenapointtype' })
    }
  }
}
</script>
